module.exports = {
  ADMIN_PROFILE: {
    user_id: 'admin',
    name: 'Soporte Viatik - Natalia',
    picture: 'https://viatik-profiles.s3.sa-east-1.amazonaws.com/natalia/profile.png'
  },
  SOCKET_URI: process.env.REACT_APP_SOCKET_URI,
  CHANNELS_MAX: 25
}
